import { StateType } from 'data/types'

export const get = (state: StateType) => state.auth.extraKYCQuestions.data

export const isFetching = (state: StateType) => state.auth.extraKYCQuestions.fetching

export const hasError = (state: StateType) => state.auth.extraKYCQuestions.hasError
